(function($, undefined) {
	
	'use strict';
	var utils = Fw.component.models().utils;

	var init = function (page) {
		var currPage    = $(page);
		
		$('.index-slider-ctn-inner').slick({
			infinite: true,
			autoplay: true,
			autoplaySpeed: 7000,
			speed: 1000,
			arrows: false,
			dots: true,
			lazyLoad: 'progressive',
			slidesToShow: 1,
			slidesToScroll: 1,
			pauseOnFocus:false,
			pauseOnHover:false,
			vertical: true,
			verticalSwiping: true,
			swipe: false,
			responsive: [
				{
					breakpoint: 600,
					settings: {
						swipe: true
					}
				}
			]
		});

		//current slide id
		var slideNameHash = $('.slick-active').data('id');
		//prefill input[type="range"] of active slide
		prefillAdminBackgroundPosRanges();
		//change slide name hash value on each slide change
		$('.index-slider-ctn-inner').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
			slideNameHash = $('.index-slider-ctn-inner').find('.index-slide').eq(nextSlide + 1).data('id');
		});
		$('.index-slider-ctn-inner').on('afterChange', function () {
			prefillAdminBackgroundPosRanges();
		});
	
		//set click listener on save btn of each slide
		$('.index-slider-background-pos-save-btn').click(function() {
			saveIndexSliderBackgroundPosition(slideNameHash);
		});
		//apply onChange event listener on every input[type="range"] of slider
		$('.index-slider-ctn-inner').find('.index-slide').each(function() {
			var slide = $(this);
			var nameHash = slide.data('id');
			slide.find('.index-slider-background-position-y-input-range-' + nameHash).on('input', function() {
				slide.css('background-position-y', $(this).val() + '%');
			});
			slide.find('.index-slider-background-position-x-input-range-' + nameHash).on('input', function() {
				slide.css('background-position-x', $(this).val() + '%');
			});
			
			slide.find('.index-slider-admin-background-option-title-' + nameHash).click(function() {
				$(this).siblings('.index-slider-admin-background-option-content-' + nameHash).toggleClass('show');
			});
		});
	};
	
	function getCurrentSlideBackgroundPosition() {
		return $('.slick-active').css('background-position');
	}
	
	function prefillAdminBackgroundPosRanges() {
				
		var posX = getCurrentSlideBackgroundPosition().split(' ')[0].trim();
		var posY = getCurrentSlideBackgroundPosition().split(' ')[1].trim();
		
		var slideNameHash = $('.slick-active').closest('.index-slide').data('id');
		$('.index-slider-background-position-x-input-range-' + slideNameHash).val(posX.replace('%', ''));
		$('.index-slider-background-position-y-input-range-' + slideNameHash).val(posY.replace('%', ''));
	}
	
	function saveIndexSliderBackgroundPosition(slideNameHash) {
		var posX = getCurrentSlideBackgroundPosition().split(' ')[0].trim();
		var posY = getCurrentSlideBackgroundPosition().split(' ')[1].trim();
		
		var posToSave = posX + " " + posY;
		
		utils.updateLabelLangs("index-slider-background-pos-slide-" + slideNameHash, posToSave, 'en,fr');
	}
	
	// Execute code only if slider exists
	var slider = Fw.component.export('slider', {
		init: init
	});
	
	
})(jQuery);
